import { Card, CardActions, Container, Slide, Typography, Grid } from "@material-ui/core";
import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Common/Footer";
import Header from "../components/Common/Header/Header";
import Button from "../components/Common/Button/Button";
import Loading from "../components/Common/Loading/Loading";

const Memories = () => {
  const [newsEvents, setNewsEvents] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleClick = (eventId) => {
    navigate(`/memories/${eventId}`);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await Axios.get("https://lawacademyadmin.icicle.dev/api/eventData");
        setLoading(true);
        const events = response.data.filter((item) => item.type === "event");
        setNewsEvents(events);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  if (!loading) {
    return <Loading />;
  }

  return (
    <>
      <Header />
      <div>
        <Container className="memory-page py-12">
          <Slide direction="right" in={true} mountOnEnter unmountOnExit>
            <Container
              className="pa-4"
              style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-around" }}
            >
              <div data-aos="fade-up">
              <Grid container spacing={3}>
                {newsEvents?.map((event) => (
                  <Grid key={event?.id} item xs={12} sm={6} md={4} lg={3}>
                    <Card
                      className="ma-3"
                      style={{ marginBottom: 20, borderRadius: 12, height: "380px" }}
                    >
                     <div>
                     <div className="image-container">
                        <img
                          src={`https://lawacademyadmin.icicle.dev/${event?.image}`}
                          alt={event?.title}
                          style={{ height: 200, width: "100%" }}
                          className="zoom-image"
                        />
                      </div>
                      <div className="text-center py-3" style={{ marginTop: "10px" }}>
                        <Typography
                          variant="h4"
                          className="font-weight-bold"
                          style={{
                            height: "80px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {event?.title}
                        </Typography>
                      </div>
                     </div>
                      <CardActions>
                        <div
                          className="buttons-set"
                          style={{ display: "inline-block", margin: "auto" }}
                        >
                          <div style={{ marginTop: "20px" }} onClick={() => handleClick(event?.id)}>
                            <Button title={"See Memories"}></Button>
                          </div>
                        </div>
                      </CardActions>
                    </Card>
                  </Grid>
                ))}
              </Grid>
              </div>
            </Container>
          </Slide>
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default Memories;
